<template>
  <div>
    <Overlay :overlay="overlay"></Overlay>
    <LogoutWarningDialog
      :dialogLogoutWarning="dialogLogoutWarning"
      @clicked="dialogLogoutWarningEmit"
    ></LogoutWarningDialog>
    <v-app-bar
      app
      density="compact"
      clipped-left
      color="transparent"
      elevation="0"
      height="80"
    >
      <v-app-bar-title>
        <div class="d-flex align-center pa-0">
          <div align="center">
            <v-img
              :width="110"
              aspect-ratio="16/9"
              cover
              src="@/assets/EztrackBlackLogo.png"
            ></v-img>
          </div>
        </div>
      </v-app-bar-title>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <b class="text-center text-red fontVariant4">Access denied</b>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>

      <v-card
        density="compact"
        elevation="0"
        class="d-flex align-center mb-1"
        v-if="$store.getters.get_user_email_id"
      >
        <v-avatar color="primary" class="mt-1 pa-0" size="40">
          <span class="fontVariant1">
            {{ $store.getters.get_user_email_id.charAt(0).toUpperCase() }}
          </span>
        </v-avatar>
        <div class="mx-2">
          <v-card-title
            class="my-0 mx-2 pa-0 fontVariant3"
            v-if="$store.getters.get_current_user_details"
          >
            {{ $store.getters.get_current_user_details.user_name }}
          </v-card-title>
          <v-card-subtitle class="my-0 mx-2 pa-0 fontVariant1">
            {{ $store.getters.get_user_email_id }}</v-card-subtitle
          >
        </div>
      </v-card>

      <v-icon
        class="ml-2 mr-12"
        color="primary"
        @click="dialogLogoutWarning = true"
      >
        mdi-logout-variant
      </v-icon>
    </v-app-bar>

    <v-main class="d-flex align-center justify-center whole-background ma-6">
      <v-container fluid>
        <v-row justify="center" align="center">
          <v-col cols="12"> </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>
<script>
import Overlay from "@/components/Extras/Overlay.vue";
import LogoutWarningDialog from "@/components/LandingPage/Dialogs/LogoutWarningDialog.vue";
export default {
  components: {
    Overlay,
    LogoutWarningDialog,
  },
  data() {
    return {
      overlay:false,
      dialogLogoutWarning: false,
    };
  },
  methods: {
    dialogLogoutWarningEmit(toggle) {
      this.dialogLogoutWarning = false;
      if (toggle === 2) {
        this.$router.push("/");
      }
    },
  },
};
</script>
<style scoped>
.whole-background {
  background-image: url("@/assets/NoAccess.webp");
  background-size: cover;
  background-position: center;
}
</style>
